import { ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { AssetUrlService } from 'src/app/services/basic/asset-url.service';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-messagebubble',
    templateUrl: './messagebubble.component.html',
    styleUrls: ['./messagebubble.component.scss'],
    standalone: false
})
export class MessagebubbleComponent implements OnInit, OnDestroy {
  private assetUrl = inject(AssetUrlService);

  @Input() text: any;
  @Input() replace_icon: any;
  @Input() replace_icon_name: any;
  @Input() appComponent: 'other' | 'tts' = 'other';
  @Input() public media_url: any = '';
  @Input() public basepath: any = '';

  language_id: any;
  get currentLanguageId(): number {
    const userId = this.data?.user?.id;
    const savedLanguageId = userId ? localStorage.getItem(`language_saved_user_${userId}`) : null;
    const parsedSavedLanguageId = savedLanguageId === null ? Number.NaN : Number(savedLanguageId);

    if (!Number.isNaN(parsedSavedLanguageId)) {
      return parsedSavedLanguageId;
    }

    return Number(this.data?.user?.language_id ?? 0);
  }

  constructor(public data: DataService, private loadingCtrl: LoadingController, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.language_id = this.currentLanguageId;
  }

  ngOnDestroy() {
    this.stopPlayback();
  }

  async play(){
    if (!this.text || this.currentLanguageId <= 0) {
      return;
    }

    if (this.data?.user && this.data.user.language_id !== this.currentLanguageId) {
      this.data.user.language_id = this.currentLanguageId;
    }

    if(this.data.ttsMediaPlayer != undefined){
      for(let i in this.data.ttsMediaPlayerSources){
        if(i != this.media_url){
          if(this.data.ttsMediaPlayerSources[i] == 'playing'){
            this.data.ttsMediaPlayer.pause();
            this.data.ttsMediaPlayer.currentTime = 0;
            this.data.ttsMediaPlayer = undefined;
          }
          this.data.ttsMediaPlayerSources[i] = '';
        }
      }
    }

    let self = this;
    if(this.media_url != '' && this.language_id == this.currentLanguageId && this.data.ttsMediaPlayer != undefined){
      this.playMedia();
    } else {
      const loading = await this.loadingCtrl.create({
        message: 'Please wait ...',
        duration: 0,
      });

      loading.present();
      this.data.testToSpeach(this.text).then((response: any) => {
        if (!response?.url) {
          loading.dismiss();
          return;
        }

        self.media_url = response.url.substring(1);
        self.language_id = self.currentLanguageId;
        self.data.ttsMediaPlayerSources[self.media_url] = '';
        self.data.ttsMediaPlayer = document.getElementById('tts-audio-player') as HTMLAudioElement | null;

        if (!self.data.ttsMediaPlayer) {
          loading.dismiss();
          return;
        }

        self.data.ttsMediaPlayer.src = self.assetUrl.mediaUrl(response.url);
        self.data.ttsMediaPlayer.load();
        self.data.ttsMediaPlayer.onplaying = (() => {
            loading.dismiss();
            self.data.ttsMediaPlayerSources[self.media_url] = 'playing';
            self.changeDetectorRef.detectChanges();
        });
        self.data.ttsMediaPlayer.onended = (() => {
          for(let i in self.data.ttsMediaPlayerSources){
            self.data.ttsMediaPlayerSources[i] = '';
          }
          self.changeDetectorRef.detectChanges();
         })
        self.playMedia();
      }, () => {
        loading.dismiss();
      });
    }
  }

  playMedia(){
    if (!this.data.ttsMediaPlayer) {
      return;
    }

    if(this.data.ttsMediaPlayerSources[this.media_url] == 'playing'){
      this.data.ttsMediaPlayer.pause();
      this.data.ttsMediaPlayerSources[this.media_url] = 'pause';
    } else {
      this.data.ttsMediaPlayer.play();
    }
  }

  private stopPlayback(): void {
    if (!this.data.ttsMediaPlayer) {
      return;
    }

    this.data.stopTTSMedia();
    this.data.ttsMediaPlayer = undefined;
  }
}
